import { PropsWithChildren, useState } from "react"
import AppTokenContext from "../context/AppTokenContext"
import { AppToken } from "../hooks/useAppToken"

export default function AppTokenProvider(props: PropsWithChildren<{}>) {
    const [token, setToken] = useState<AppToken>()
    return <AppTokenContext.Provider value={{token, setToken}}>{props.children}</AppTokenContext.Provider>
}